<!--
 * @Author: 单译 2694138418@qq.com
 * @Date: 2022-09-20 15:09:54
 * @LastEditors: 单译 2694138418@qq.com
 * @LastEditTime: 2022-11-30 18:36:05
 * @FilePath: \music\src\view\loading.vue
 * @Description: 
 * 
 * Copyright (c) 2022 by 单译 2694138418@qq.com, All Rights Reserved. 
-->
<template>
    <div class="load-model" v-show="showLoading">
        <lottie class="" :options="defaultOptions" :width="100" :height="100" />
    </div>
</template>
  
<script>
import Anim from '@/assets/json/loading.json'

export default {
    data() {
        return {
            defaultOptions: { animationData: Anim, loop: true, autoplay: true },
        }
    },
    props: {
        showLoading: false
    }
}
</script>
  
<style scoped>
.load-model {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99999;
}
</style>